



import React, { useState, useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { toPng } from 'html-to-image';
import './qrcode.css';

const QRGenerator = () => {
  const [brandName, setBrandName] = useState('');
  const [url, setUrl] = useState('https://example.com');
  const qrRef = useRef(null);

  const handleDownload = () => {
    if (qrRef.current) {
      toPng(qrRef.current)
        .then((dataUrl) => {
          const link = document.createElement('a');
          link.download = `${brandName || 'qr'}-${Date.now()}.png`;
          link.href = dataUrl;
          link.click();
        });
    }
  };

  return (
    <div className="qr-app">
      {/* Input Section */}
      <div className="input-section">
        <h1 className="app-title">Professional QR Generator</h1>
        
        <div className="input-group">
          <label htmlFor="brand">Brand Name</label>
          <input
            id="brand"
            type="text"
            value={brandName}
            onChange={(e) => setBrandName(e.target.value)}
            placeholder="Brand/Organization Name"
          />
        </div>



        <div className="input-group">
          <label htmlFor="url">Destination URL</label>
          <input
            id="url"
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://yourwebsite.com"
            required
          />
        </div>
      </div>

      {/* QR Display Section */}
      <div className="qr-display">
        <div className="qr-container" ref={qrRef}>
          <QRCodeSVG 
            value={url}  // Just the URL (best compatibility)
            size={200}
            level="H"
            includeMargin
          />
          {brandName && <p className="brand-name">{brandName}</p>}
        </div>
        <button className="download-btn" onClick={handleDownload}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15V3M12 15L8 11M12 15L16 11M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Download QR
        </button>
      </div>
    </div>
  );
};

export default QRGenerator;